<script setup lang="ts">
import {ExternalLink, Fence, Hammer, Trees} from "lucide-vue-next";

import "@/assets/styles/reference.css";

const references = [
  {
    icon: Trees,
    title: "Moderner Familiengarten",
    category: "Gartenpflege & Gestaltung",
    text: "Komplette Neugestaltung eines privaten Gartens inklusive Rollrasen, Bepflanzung und Beleuchtung."
  },
  {
    icon: Fence,
    title: "Sichtschutz & Zaunanlage",
    category: "Sichtschutz",
    text: "Hochwertige Sichtschutzlösung mit langlebigen Materialien für mehr Privatsphäre im Außenbereich."
  },
  {
    icon: Hammer,
    title: "Terrasse & Pflasterarbeiten",
    category: "Pflasterarbeiten",
    text: "Moderne Terrassenfläche mit sauber verlegtem Pflaster und stilvoller Gestaltung."
  }
];
</script>

<template>

  <section class="references-section" id="references">

    <!-- Header -->
    <div class="references-header">

      <span class="section-badge">
        Referenzen
      </span>

      <h2>
        Einblicke in unsere Projekte
      </h2>

      <p>
        Jedes Projekt wird individuell geplant und professionell umgesetzt –
        von kleinen Gartenarbeiten bis zu kompletten Außenanlagen.
      </p>

    </div>

    <!-- Grid -->
    <div class="references-grid">

      <div
          class="reference-card"
          v-for="reference in references"
          :key="reference.title"
      >

        <!-- Bild -->
        <div class="reference-image">

          <div class="image-overlay">
            <ExternalLink/>
          </div>

        </div>

        <!-- Inhalt -->
        <div class="reference-content">

          <div class="reference-icon">
            <component :is="reference.icon"/>
          </div>

          <span class="reference-category">
            {{ reference.category }}
          </span>

          <h3>
            {{ reference.title }}
          </h3>

          <p>
            {{ reference.text }}
          </p>

        </div>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>